export const normalizeCategoryName = (name = "") =>
  name
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[\s\-_–—]+/g, " ")
    .trim();

const MASTER_CATEGORIES = [
  "End Of Life",
  "Peer-to-Peer",
  "Remote Desktop Sharing",
  "Hacking & Security Tools",
  "Cryptocurrency Mining",
  "Unauthorized Data Transfer",
  "Virtualization and Scripting",
];

export const isEndOfLifeCategory = (category) =>
  normalizeCategoryName(category.categoryName) === "end of life";

export const mergeHighRiskSoftwareCategories = (categories = []) => {
  const infoByNormalized = new Map(
    categories.map((category) => [
      normalizeCategoryName(category.categoryName),
      {
        apiCategoryName: category.categoryName,
        softwareCount: category.softwareCount ?? 0,
      },
    ]),
  );
  const knownNormalized = new Set(
    MASTER_CATEGORIES.map(normalizeCategoryName),
  );

  const merged = MASTER_CATEGORIES.map((masterName) => {
    const info = infoByNormalized.get(normalizeCategoryName(masterName));
    return {
      categoryName: info?.apiCategoryName ?? masterName,
      softwareCount: info?.softwareCount ?? 0,
    };
  });
  const extras = categories.filter(
    (category) =>
      !knownNormalized.has(normalizeCategoryName(category.categoryName)),
  );
  const byCountDesc = (a, b) =>
    (b.softwareCount ?? 0) - (a.softwareCount ?? 0);
  const [endOfLife, rest] = merged.reduce(
    ([eol, remaining], category) =>
      isEndOfLifeCategory(category)
        ? [[...eol, category], remaining]
        : [eol, [...remaining, category]],
    [[], []],
  );

  return [
    ...endOfLife,
    ...rest.sort(byCountDesc),
    ...extras.sort(byCountDesc),
  ];
};
